import { apiFetch } from "../utils/apiFetch";

/** Datenbereinigung „Outlook-Importe“ — Backend: datenbereinigung/outlook-importe. */
export type OutlookListe = "pendant" | "ohne" | "sonderzeichen";

export interface OutlookReiter {
  quelle: string;
  label: string;
  offen: number;
}

export interface OutlookPendant {
  id: number;
  lastname: string | null;
  firstName: string | null;
  contactNbrInt: string | null;
  typ: string | null;
  status: string | null;
  anschrift: string | null;
  persoenlich: boolean;
  ausImport: boolean;
  gruende: string[];
}

export interface OutlookImportZeile {
  id: number;
  lastname: string | null;
  firstName: string | null;
  contactNbrInt: string | null;
  employer: string | null;
  occupation: string | null;
  typ: string | null;
  status: string | null;
  email: string | null;
  telefon: string | null;
  anschrift: string | null;
  pendants: OutlookPendant[];
}

const BASIS = "datenbereinigung/outlook-importe";

export const fetchOutlookReiter = async (): Promise<OutlookReiter[]> => {
  const { data } = await apiFetch<OutlookReiter[]>(`${BASIS}/reiter`);
  return data ?? [];
};

export const listOutlookImporte = async (
  quelle: string,
  liste: OutlookListe,
  q: string | undefined,
  limit: number,
  offset: number,
  signal?: AbortSignal,
): Promise<{ rows: OutlookImportZeile[]; total: number }> => {
  const { data, total } = await apiFetch<OutlookImportZeile[]>(
    `${BASIS}/${encodeURIComponent(quelle)}`,
    { params: { liste, limit, offset, ...(q ? { q } : {}) }, signal },
  );
  return { rows: data ?? [], total: total ?? data?.length ?? 0 };
};

const post = async <T,>(pfad: string, ids: number[]): Promise<T> => {
  const { data } = await apiFetch<T>(pfad, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ids }),
  });
  return data;
};

/** „Importieren“: Kontakte erscheinen ab jetzt in Tabelle und Suche. */
export const outlookFreigeben = (quelle: string, ids: number[]) =>
  post<{ freigegeben: number }>(`${BASIS}/${encodeURIComponent(quelle)}/freigeben`, ids);

/** Outlook-Person in eine Firma umwandeln (Vor- + Nachname → Firmenname). */
export const outlookZuFirma = (quelle: string, ids: number[]) =>
  post<{ umgewandelt: number }>(`${BASIS}/${encodeURIComponent(quelle)}/zu-firma`, ids);

/** Merge-Seite mit dem bestehenden Kontakt als Sieger und Rücksprung hierher. */
export const outlookMergeLink = (bestehendId: number, importId: number, zurueck: string) =>
  `/contacts/merge?clusterIds=${bestehendId},${importId}&importIds=${importId}&survivorId=${bestehendId}&zurueck=${encodeURIComponent(zurueck)}`;
